import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { change, reduxForm } from 'redux-form';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { get } from 'lodash';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import ComposedUpload from '@inqool/uas-web-core/es/components/controls/Upload';

import { Preview } from '@components/form/Upload/Upload';
import { InlineGridField, InlineGrid } from '@components/form';
import { Loader } from '@components/loader';
import { photosGridColumns } from './_bicyclesColumns';
import { BicycleFormPhotos } from './BicycleFormPhotos';

const mapStateToProps = state => ({
  bicyclePhotos: get(state, 'form.module-bicycles.values.photos'),
  photos: get(state, 'form.module-bicycles-photos.values.photos')
});

const mapDispatchToProps = dispatch => ({
  addPhotosToBicycle: photos => dispatch(change('module-bicycles', 'photos', photos)),
  savePhotos: photos => dispatch(change('module-bicycles-photos', 'photos', photos))
});

let inProgressCount = 0;

const enhance = compose<any, any>(
  reduxForm({ form: 'module-bicycles-photos', initialValues: { photos: [] } }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('inProgress', 'setInProgress', false),
  withHandlers({
    updateProgress: ({ setInProgress }) => value => {
      inProgressCount = value < 0 ? 0 : value;
      setInProgress(!!inProgressCount);
    }
  }),
  withHandlers({
    onChange: ({ photos, savePhotos, updateProgress }) => data => {
      savePhotos([...photos, data]);
      updateProgress(inProgressCount - 1);
    },
    onSubmit: ({ bicyclePhotos, photos, addPhotosToBicycle, closeItem }) => () => {
      addPhotosToBicycle([...bicyclePhotos, ...photos]);
      closeItem();
    }
  }),
  lifecycle<any, any>({
    componentWillUnmount() {
      this.props.updateProgress(0);
    }
  })
);

const View: any = ({ photos, closeItem, onChange, onSubmit, inProgress, updateProgress }) => {
  return (
    <div style={{ margin: '15px', maxHeight: '500px', overflow: 'auto' }}>
      {!!inProgress && <Loader />}
      <Grid fluid={true}>
        <Row className="without-min-width">
          <Col md={12}>
            <InlineGridField
              component={InlineGrid}
              name="photos"
              columns={photosGridColumns}
              Form={BicycleFormPhotos}
              ActionBar={() => (
                <div style={{ display: 'flex', alignItems: 'center', height: '36px', cursor: 'pointer' }}>
                  <ComposedUpload
                    value={null}
                    url="/metropolis/api/files/"
                    accept="image/*"
                    View={Preview}
                    onChange={onChange}
                    fullWidth={true}
                    multiple={true}
                    onStart={f => updateProgress(inProgressCount + f.length)}
                    onError={() => updateProgress(inProgressCount - 1)}
                    onAbort={() => updateProgress(inProgressCount - 1)}
                  />
                </div>
              )}
              showCheckboxes={true}
              deleting={true}
              editing={true}
              adding={false}
            />
          </Col>
        </Row>
      </Grid>

      <Button
        label="Uložit"
        style={{ margin: '16px 0 16px 16px' }}
        onClick={onSubmit}
        primary={true}
        disabled={!photos || !photos.length}
      />
      <Button label="Zavřít" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </div>
  );
};

export const BicyclesFormPhotosMultipleUploader = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/bicycles/BicyclesFormPhotosMultipleUploader.tsx